<template>
  <div id="help-login-detail" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/login"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart pb-50 l-check-cart__head">
              <div class="l-check-cart__title text-left">アカウント連携</div>
              <div class="help-card mb-16">
                <div class="l-check-cart__title text-left">Appleアカウントでサインイン<br />（初めて登録する場合）</div>
                <div class="detail-wrap">
                  <p class="l-check-cart__title text-left">1.Appleでサインインボタンをタップ</p>
                  <p>「Appleでサインイン」ボタンをタップしてください。</p>
                  <img class="border" src="/assets/images/help/help-login-apple-1.png" alt="" />
                </div>
                <div class="detail-wrap">
                  <p class="l-check-cart__title text-left">2. Apple IDでAppleにサインイン</p>
                  <img class="help-m-b-16 border" src="/assets/images/help/help-login-apple-2.png" alt="" />
                  <p class="help-m-b-16">①Apple IDに登録されたメールアドレスを利用する場合は「メールを共有」をタップしてください。</p>
                  <p class="help-m-b-16">
                    ②メールを非公開にしたい場合は、「メール非公開」をタップしてください。
                    ランダムなメールアドレスがAppleで作成され、そのアドレスがアプリに登録されます。
                    アプリの各種通知メールは、作成されたメールアドレス宛に送信されますが、Apple IDに登録されたメールアドレスに自動転送されます。
                  </p>
                  <p class="help-m-b-16">③「パスコードで続ける」（Touch IDの場合は「Touch IDで続ける」、Face IDの場合は「続ける」が表示されます）をタップして認証し、サインインします。</p>
                  <p class="note">※デバイスコードを設定していない場合はApple IDのパスワードを入力 </p>
                </div>
              </div>
              <div class="help-card mb-51">
                <div class="l-check-cart__title text-left">Appleアカウントでサインイン<br />（一度登録している場合）</div>
                <div class="detail-wrap">
                  <p class="l-check-cart__title text-left">1.Appleでサインインボタンをタップ</p>
                  <img class="help-m-b-40 border" src="/assets/images/help/help-login-apple-3.png" alt="" />
                  <p class="l-check-cart__title text-left">2. 下部のボタンをタップ</p>
                  <img class="help-m-b-16 border" src="/assets/images/help/help-login-apple-4.png" alt="" />
                  <p>
                    「パスコードで続ける」（Touch IDの場合は「Touch IDで続ける」、Face IDの場合は「続ける」が表示されます）をタップして認証し、サインインします。
                      ※デバイスコードを設定していない場合はApple IDのパスワードを入力 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpLoginDetail",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>